import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { ErrorBoundary } from "react-error-boundary";

import SnackbarProvider from "./contexts/SnackbarProvider";
import { AuthProvider } from "./contexts/AuthContext";
import { cacheableApiCall } from "./utils/apiCall";
import { AppRoutes } from "./Routes";
import Layout from "./panel/Layout";
import "./App.css";
import ErrorPage from "./components/ErrorPage";
import { ThemeProvider } from "@mui/material/styles";
import LightTheme from "./panel/theme/lightTheme";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: cacheableApiCall,
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  },
});

function App() {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorPage}
      onReset={() => window.location.reload()}
    >
      <ThemeProvider theme={LightTheme}>
        <AuthProvider>
          <SnackbarProvider>
            <QueryClientProvider client={queryClient}>
              <Layout>
                <AppRoutes />
              </Layout>
              <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
          </SnackbarProvider>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
